import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultToasts } from "../../../../Constant";
import { DEFAULT_TOAST } from "../../../../Data/Bonus Ui/Toasts";
import { Btn, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { useState } from "react";

const DefaultToast = () => {
  const [open, setOpen] = useState(true);
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={DefaultToasts} span={DEFAULT_TOAST} />
        <CardBody className="toast-rtl">
          <Toast className="default-show-toast" isOpen={open}>
            <div className="toast-header toast-img">
              <Image className="rounded me-2" src={dynamicImage("avtar/profile.png")} alt="profile" />
              <strong className="me-auto">Boho theme</strong>
              <small className="d-sm-block d-none">10 min ago</small>
              <Btn className="btn-close p-0" onClick={() => setOpen(false)}></Btn>
            </div>
            <ToastBody className="toast-dark"><strong className="txt-success">Well done!</strong> You successfully read this important message.</ToastBody>
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultToast;
